import firebase from "firebase/app";
import "firebase/firestore";

var firebaseConfig = {
  apiKey: "AIzaSyCir0wvT264qIVUyq5AwSET6C3J5jDG1GM",
  authDomain: "news-feed-fe65d.firebaseapp.com",
  databaseURL: "https://news-feed-fe65d.firebaseio.com",
  projectId: "news-feed-fe65d",
  storageBucket: "news-feed-fe65d.appspot.com",
  messagingSenderId: "825695890837",
  appId: "1:825695890837:web:089665a8c047ffb10c1a9c",
  measurementId: "G-HMPHBM759N"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();

export default db;
